import Layout from "@/src/layout/Layout";
import BlockContent from "@sanity/block-content-to-react";
import Link from "next/link";
import { client, urlFor } from "../../lib/client";
import formatDateToCustomFormat from "../../utils/dateFormatter";
import { Fragment } from "react";
import { NextSeo, ArticleJsonLd } from 'next-seo';
import Image from "next/image";

const BlogDetails = ({blogData, recentNewsFetch,    fetchFooter,
  fetchHeader, fHeaderMenuData}) => {

  const {banner_image, author_data, slug, title, seo, tags,publishedAt,  body, comments } = blogData;
  const { jsonLtd, metaDescription, metaTitle, seo_image, type } = seo;
console.log(tags);

  return (
    <Fragment>
       <NextSeo
            title={metaTitle}
            description={metaDescription}
            canonical={`/insights/${slug.current}`}
            robots="index, follow"
            openGraph={{
              type: type,
              url: `/insights/${slug.current}`,
              title: metaTitle,
              description: metaDescription,
              image: urlFor(seo_image).url(),
            }} 
        />
        <ArticleJsonLd
     dataArray={JSON?.parse(jsonLtd)}
        />


    <Layout footerData={fetchFooter} headerData={fetchHeader} menuData={fHeaderMenuData} >
      {/* Page Banner Start */}
      <section
        className="page-banner-area overlay pt-250 pb-50 rel z-1 bgs-cover"
        style={{
          backgroundImage: `url(${urlFor(banner_image)})`,
        }}
      >
        <div className="container">
          <div className="banner-inner">
            <div className="row">
              <div className="col-xl-8">
                <ul className="blog-meta mb-15 wow fadeInUp delay-0-2s">
                  <li>
                    <i className="fal fa-user-alt" />
                    <a href="#"> {author_data.name} </a>
                  </li>
                  <li>
                    <i className="far fa-calendar-alt" />
                    <a href="#"> {formatDateToCustomFormat(publishedAt)}  </a>
                  </li>
                  <li>
                    <i className="far fa-comments" />
                    <a href="#">Comment  {comments?.length} </a>
                  </li>
                </ul>
                <h2 className="page-title wow fadeInUp delay-0-3s">
                 {title}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Page Banner End */}
      {/* Blog Details Page Area start */}
      <section className="blog-details-page py-130 rpy-100 rel z-1">
        <div className="container container-1290">
          <div className="row gap-60">
            <div className="col-lg-8">
              <div className="blog-single-content">
                {/* blog start here */}
                 <BlockContent
                  blocks={body}
                  projectId="82wyjz97"
                  dataset="production"

                  serializers={{
                    types: {
                      dualImage: (props) => {
                        return (
                          <div className="row mt-50 pb-20">
                          <div className="col-md-6">
                            <div className="image mb-30 wow fadeInUp delay-0-2s">
                            <img src={urlFor(props.node.image1)} alt="Image 1" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="image mb-30 wow fadeInUp delay-0-4s">
                            <img src={urlFor(props.node.image2)} alt="Image 2" />
                            </div>
                          </div>
                        </div>
                        );
                      },
                      blockQuote: (props) => {
                        return (
                          <div className="py-30">
                          <blockquote>
                          {props.node.text}
                           <span className="blockquote-footer"> {props.node.paragraph} </span>
                         </blockquote>
                         </div>
                        );
                      },
                      block: (props) => {
                        switch (props.node.style) {
                          case "h1":
                            return (
                              <h1
                                initial={{ x: -100, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                transition={{ duration: 0.75 }}
                                className="text-4xl font-bold py-3"
                              >
                                {props.children}
                              </h1>
                            );
                          case "h2":
                            return (
                              <h2
                               
                                className="text-4xl font-bold py-3"
                              >
                                {props.children}
                              </h2>
                            );
                          case "h3":
                            return (
                              <h3 className="text-2xl font-semibold py-3">
                                {props.children}
                              </h3>
                            );
                          case "h4":
                            return (
                              <h4 className="text-xl font-semibold">
                                {props.children}
                              </h4>
                            );
                          case "h5":
                            return (
                              <h5 className="text-lg font-semibold ">
                                {props.children}
                              </h5>
                            );
                          case "h6":
                            return (
                              <h6 className="text-base font-semibold ">
                                {props.children}
                              </h6>
                            );
                          case "image":
                            return (
                              <div className="image mb-155 rmb-100 wow fadeInUp delay-0-2s">
                              <Image  alt={seo.metaTitle} className="" src={props.children} />
                              </div>
                            );
                            case "dualImage":
                              return (
                                <div className="row mt-50 pb-20">
                                <div className="col-md-6">
                                  <div className="image mb-30 wow fadeInUp delay-0-2s">
                                  <img src={urlFor(props.node.image1)} alt="Image 1" />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="image mb-30 wow fadeInUp delay-0-4s">
                                  <img src={urlFor(props.node.image2)} alt="Image 2" />
                                  </div>
                                </div>
                              </div>
                               
                              );
                          
                            case "firstText":
                              return (
                                <p className="big-first-letter">
                                {props.children}
                                </p>
                              );
                            
                          default:
                            return (
                              <p>
                                {props.children}
                              </p>
                            );
                        }
                      },
                    },
                  }}
                />
 
              </div>
              <div className="tag-share py-30 wow fadeInUp delay-0-2s">

               
              </div>
              <div className="admin-comment bgc-lighter wow fadeInUp delay-0-2s">
                <div className="comment-body">
                  <div className="author-thumb">
                    <img
                      src={urlFor(author_data.image)}
                      alt="Author"
                    />
                  </div>
                  <div className="content">
                    <h5> {author_data.name} </h5>
                    <p>
                    {author_data.bio}
                    </p>
                 
                  </div>
                </div>
              </div>

              <h3 className="comment-title mb-50">Popular Comments</h3>
              <div className="comments">
                {comments?.map((item, index) => (
   <div key={index} className="comment-body wow fadeInUp delay-0-2s">
   <div className="author-thumb">
     <img
       src={urlFor(item.image)}
       alt="Author"
     />
   </div>
   <div className="content">
     <ul className="blog-meta">
       <li>
         <h6> {item.name} </h6>
       </li>
       <li>
         <a href="#"> {formatDateToCustomFormat(item.publishedAt)} </a>
       </li>
     </ul>
     <p>
     {item.comment}
     </p>
    
   </div>
 </div>
                ))}
             

              </div>
              <form
                id="comment-form"
                className="comment-form bgc-lighter mt-95 wow fadeInUp delay-0-2s"
                name="comment-form"
                action="#"
                method="post"
              >
                <h4>Leave a Reply</h4>
                <p>
                  we denounce with righteous indignation and dislike men who
                  beguiled
                </p>
                <div className="row mt-30">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="full-name"
                        name="full-name"
                        className="form-control"
                        placeholder="Full Name"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="blog-email"
                        name="blog-email"
                        className="form-control"
                        placeholder="Email Address"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="url"
                        id="website"
                        name="website"
                        className="form-control"
                        placeholder="Website"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <textarea
                        name="message"
                        id="message"
                        className="form-control"
                        rows={4}
                        placeholder="Message"
                        required={""}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-0">
                      <button
                        type="submit"
                        className="theme-btn style-two w-100"
                      >
                        Send a Reply <i className="far fa-arrow-right" />
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="col-lg-4">
              <div className="main-sidebar rmt-75">
                  {/* search section commented out */}
                {/* <div className="widget widget-search wow fadeInUp delay-0-2s">
                  <form action="#" className="default-search-form">
                    <input type="text" placeholder="Search..." required />
                    <button
                      type="submit"
                      className="searchbutton far fa-search"
                    />
                  </form>
                </div> */}
                <div className="widget widget-author wow fadeInUp delay-0-4s">
                  <img src={urlFor(author_data.image)} alt="Author" />
                  <h5> {author_data.name} </h5>
                  <p>
                   {author_data.bio}
                  </p>
                  <div className="social-style-one">
                    <a href={`https://twitter.com/intent/tweet?url=https://techcelerant.com/blogs/${slug.current}
`} target="_blank">
                      <i className="fab fa-twitter" />
                    </a>
                    <a href={`https://www.facebook.com/sharer/sharer.php?u=https://techcelerant.com/blogs/${slug.current}`} target="_blank">
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a href={`https://www.linkedin.com/shareArticle?mini=true&url=https://techcelerant.com/blogs/${slug.current}&title=${title}&summary=Discover%20the%20intricacies%20of%20digital%20marketing%20in%20the%20technology%20realm%20on%20our%20latest%20blog%20post.`} target="_blank">
                      <i className="fab fa-linkedin" />
                    </a>
                    <a href={`https://www.pinterest.com/pin/create/button/?url=https://techcelerant.com/blogs/${slug.current}`} target="_blank">
                      <i className="fab fa-pinterest-p" />
                    </a>
                  </div>
                </div>
                {/* category section commented out */}
                {/* <div className="widget widget-category wow fadeInUp delay-0-2s">
                  <h4 className="widget-title">Category</h4>
                  <ul>
                    <li>
                      <Link legacyBehavior href="/blog">
                        <a>Web Design</a>
                      </Link>{" "}
                      <span>(5)</span>
                    </li>
                    <li>
                      <Link legacyBehavior href="/blog">
                        <a>SEO Optimizations</a>
                      </Link>{" "}
                      <span>(3)</span>
                    </li>
                    <li>
                      <Link legacyBehavior href="/blog">
                        <a>Mobile Apps Design</a>
                      </Link>{" "}
                      <span>(2)</span>
                    </li>
                    <li>
                      <Link legacyBehavior href="/blog">
                        <a>Development</a>
                      </Link>{" "}
                      <span>(4)</span>
                    </li>
                    <li>
                      <Link legacyBehavior href="/blog">
                        <a>Graphics Design</a>
                      </Link>{" "}
                      <span>(6)</span>
                    </li>
                    <li>
                      <Link legacyBehavior href="/blog">
                        <a>3D Illustrations</a>
                      </Link>{" "}
                      <span>(2)</span>
                    </li>
                  </ul>
                </div> */}
                <div className="widget widget-recent-news wow fadeInUp delay-0-2s">
                  <h4 className="widget-title">Recent Blogs</h4>
                  <ul>
              
                    {recentNewsFetch.map((item, index) => (
                 
                        <li key={index}>
                        <div className="image">
                          <img style={{  maxHeight: '100px',  minHeight: '100px'  }} src={urlFor(item.mainImage)} alt="News" />
                        </div>
                        <div className="content">
                          <h5>
                            <Link legacyBehavior href={`/insights/${item.slug.current}`}>
                              <a>
                          {item.title}
                              </a>
                            </Link>
                          </h5>
                          <span className="date">
                            <i className="far fa-calendar-alt" />
                            <a href="#"> {formatDateToCustomFormat(item.publishedAt)} </a>
                          </span>
                        </div>
                      </li>
                  
                    ))}
                  </ul>
                </div>
                <div className="widget widget-tag-cloud wow fadeInUp delay-0-2s">
                  <h4 className="widget-title">Popular Tags</h4>
                  <div className="tag-coulds">
                    {tags.map((item, index) => (
                        <Link key={index} legacyBehavior href="/blog">
                         <a> {item}  </a>
                        </Link>
                    ))}

                  </div>
                </div>
                {/* gallery section commented out */}
                {/* <div className="widget widget-gallery wow fadeInUp delay-0-2s">
                  <h4 className="widget-title">Gallery</h4>
                  <div className="gallery">
                    <Link legacyBehavior href="/blog">
                      <a>
                        <img
                          src="/assets/images/widget/gallery1.jpg"
                          alt="Gallery"
                        />
                        <i className="far fa-arrow-right" />
                      </a>
                    </Link>
                    <Link legacyBehavior href="/blog">
                      <a>
                        <img
                          src="/assets/images/widget/gallery2.jpg"
                          alt="Gallery"
                        />
                        <i className="far fa-arrow-right" />
                      </a>
                    </Link>
                    <Link legacyBehavior href="/blog">
                      <a>
                        <img
                          src="/assets/images/widget/gallery3.jpg"
                          alt="Gallery"
                        />
                        <i className="far fa-arrow-right" />
                      </a>
                    </Link>
                    <Link legacyBehavior href="/blog">
                      <a>
                        <img
                          src="/assets/images/widget/gallery4.jpg"
                          alt="Gallery"
                        />
                        <i className="far fa-arrow-right" />
                      </a>
                    </Link>
                    <Link legacyBehavior href="/blog">
                      <a>
                        <img
                          src="/assets/images/widget/gallery5.jpg"
                          alt="Gallery"
                        />
                        <i className="far fa-arrow-right" />
                      </a>
                    </Link>
                    <Link legacyBehavior href="/blog">
                      <a>
                        <img
                          src="/assets/images/widget/gallery6.jpg"
                          alt="Gallery"
                        />
                        <i className="far fa-arrow-right" />
                      </a>
                    </Link>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Blog Details Page Area end */}
      {/* footer area start */}
    </Layout>

    </Fragment>
  );
};

export const getServerSideProps = async (context) => {
  const pageSlug = context.query.slug;
  if (!pageSlug) {
    return {
      notFound: true,
    };
  }


  const query = `*[_type == "Blog" && slug.current == "${pageSlug}"]{
    ...,
    "author_data": author->{
      ...,
    },
  }[0]`;
  const blogData = await client.fetch(query);

  const categoryData = `*[_type == "category"]`
  const fetchedCategory = await client.fetch(categoryData);

  // recent news

  const recentNews = `*[_type == "Blog"]{
    slug,
      title,
      publishedAt,
      mainImage,
    
    }`;
    const recentNewsFetch = await client.fetch(recentNews);

  // fetching layouts
  const queryForFooter = `*[ _type == "Footer"  ][0]`;
  const fetchFooter = await client.fetch(queryForFooter);

  const queryForHeader = `*[ _type == "Header"  ][0]`;
  const fetchHeader = await client.fetch(queryForHeader);


 // fetching header data
 const headMenuData = `*[ _type == "Header"  ]{
  menu_items[]->{
           title,
           slug,
           menu_name,
           menu_name_number,
 }
}[0]`;
const fHeaderMenuData =  await client.fetch(headMenuData);
const headerDataForMenu = fHeaderMenuData.menu_items;

  return {
    props: {
      blogData,
      fetchedCategory,
      fetchFooter,
      fetchHeader,
      recentNewsFetch,
      fHeaderMenuData: headerDataForMenu,
    },
  };
};



export default BlogDetails;
